import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms76x/mocker'
import moment from 'moment'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hrms76x/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    let dteyreap = moment().year()
    if (typeof searchParams !== 'undefined') {
      dteyreap = (typeof searchParams.year !== 'undefined' ? searchParams.year : dteyreap)
      sendParams = {
        p_codcomp: (typeof searchParams.codcomp !== 'undefined' ? searchParams.codcomp : ''),
        p_codpos: (typeof searchParams.codpos !== 'undefined' ? searchParams.codpos : 'P'),
        p_codempid_query: (typeof searchParams.codempid3 !== 'undefined' ? searchParams.codempid3 : '')
      }
    }
    return instance().get(endpoint + '/hrms76x/index/' + dteyreap, { params: sendParams })
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms76x/index.js